import { type HTMLAttributes } from "react";

import { cn } from "./cn";

type Tone = "neutral" | "success" | "accent";

const tones: Record<Tone, string> = {
  neutral: "bg-paper text-muted ring-line",
  success: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  accent: "bg-blue-50 text-accent ring-blue-200",
};

export const Badge = ({
  tone = "neutral",
  className,
  ...props
}: HTMLAttributes<HTMLSpanElement> & { tone?: Tone }) => (
  <span
    className={cn(
      "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium ring-1 ring-inset",
      tones[tone],
      className,
    )}
    {...props}
  />
);
